import React, { PropsWithChildren } from 'react';

import styles from './Notes.module.scss';

interface NotesProps extends PropsWithChildren {}

const Notes: React.FC<NotesProps> = ({ children }) => {
  return <div className={styles.title}>{children}</div>;
};

export default Notes;
